import React from 'react'
import { FaGithub } from 'react-icons/fa'
import { FaGitAlt } from 'react-icons/fa'
import { SiMongodb } from 'react-icons/si'
import { IoLogoNodejs } from 'react-icons/io5'
import { SiExpress } from 'react-icons/si'
import { LuBrainCircuit } from 'react-icons/lu'
import { FaAws } from 'react-icons/fa6'
import { BiLogoPostgresql } from 'react-icons/bi'
import { SiVercel } from 'react-icons/si'
import { TbBrandMysql } from 'react-icons/tb'
// import { RiNpmjsLine } from 'react-icons/ri'
// import { SiPnpm } from 'react-icons/si'

const Backend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Backend Development</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <IoLogoNodejs />
            <div>
              <h3 className="skills__name">NodeJs</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <TbBrandMysql />
            <div>
              <h3 className="skills__name">MySQL</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <SiMongodb />
            <div>
              <h3 className="skills__name">MongoDB</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <FaGitAlt />
            <div>
              <h3 className="skills__name">Git</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          {/* <div className="skills__data">
            <RiNpmjsLine />
            <div>
              <h3 className="skills__name">npm</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div> */}
          <div className="skills__data">
            <SiVercel />
            <div>
              <h3 className="skills__name">Vercel</h3>
              <span className="skills__level">Basic</span>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <SiExpress />
            <div>
              <h3 className="skills__name">ExpressJS</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>

          <div className="skills__data">
            <BiLogoPostgresql />
            <div>
              <h3 className="skills__name">PostgreSQL</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <LuBrainCircuit />
            <div>
              <h3 className="skills__name">ML</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <FaGithub />
            <div>
              <h3 className="skills__name">GitHub</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          {/* <div className="skills__data">
            <SiPnpm />
            <div>
              <h3 className="skills__name">pnpm</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div> */}
          <div className="skills__data">
            <FaAws />
            <div>
              <h3 className="skills__name">AWS</h3>
              <span className="skills__level">Basic</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Backend
